/* eslint eol-last: 'off', block-spacing: 'off', brace-style: 'off' */
//import { utils, read, writeFileXLSX } from "xlsx";
//import XLSX from "js-xlsx";
import XLSX from "xlsx";
import util from "util";
// { set_cptable: [Getter],
//     set_fs: [Getter],
//     version: [Getter],
//     parse_xlscfb: [Getter],
//     parse_zip: [Getter],
//     read: [Getter],
//     readFile: [Getter],
//     readFileSync: [Getter],
//     write: [Getter],
//     writeFile: [Getter],
//     writeFileSync: [Getter],
//     writeFileAsync: [Getter],
//     writeXLSX: [Getter],
//     writeFileXLSX: [Getter],
//     utils: [Getter],
//     stream: [Getter],
//     SSF: [Getter],
//     CFB: [Getter] }
import common from '@/scripts/common'
import current from '@/scripts/current'
import commonXlsxBuilder from '@/scripts/commonXlsxBuilder';

export default {
    createWorkbook,
    createIntroduction,
    formatWorksheetName,
    writeChiSquare
}

function createWorkbook(reportModel, state, vm) {

    //var util = require('util');
    // var xlsx = require('xlsx');
    // console.log("util.inspect(XLSX)");
    // console.log(util.inspect(XLSX));

    vm.xlsxWorkspace = {
        defs: [],
        sheets: [],
        theCrosstabs: vm.$refs.theCrosstabs,
        // first: vm.$refs.theCrosstabs[0].models,
        // firstb: vm.$refs.theCrosstabs[0].controlLevels
    };
    // console.log("util.inspect(XLSX.utils)");
    // console.log(util.inspect(XLSX.utils));

    var wb = XLSX.utils.book_new();
    //console.log(tabNames);

    const p = buildParameters(reportModel, state);
    var ws = createIntroduction(p);
    XLSX.utils.book_append_sheet(wb, ws, "Introduction");
    if (p.theReportModel.missingData && p.theReportModel.missingData.hasMissing)
        XLSX.utils.book_append_sheet(
            wb,
            commonXlsxBuilder.createMissingDataWorksheet(p.theReportModel),
            "Missing Data"
        );

    let defs = [];
    p.dataByControl1.forEach((c1) => {
        c1.levelsGroupedByControl2.forEach((c2) =>
            defs.push({
                c1: c1,
                c2: c2,
                control1LevelId: c1.control1Level ? c1.control1Level.id : 0,
                control2LevelId: c2.control2Level ? c2.control2Level.id : 0,
                levelsGroupedByRows: c2.levelsGroupedByRows,
            })
        );
    });
    defs.forEach((d) => addCrosstabData(vm, d));

    // ct.models
    // ct.controlLevels.control1.id = control1LevelId
    // ct.controlLevels.control2.id
    vm.xlsxWorkspace.defs = defs;

    defs.forEach(
        (d) =>
        (d.name = formatWorksheetName(
            p,
            d.control1LevelId,
            d.control2LevelId
        ))
    );
    defs.forEach((d) => (d.worksheet = d.crosstab.createXlsxWorksheet(p, d)));
    vm.xlsxWorkspace.defs = defs;

    defs.forEach((d) => XLSX.utils.book_append_sheet(wb, d.worksheet, d.name));
    //XLSX.utils.book_append_sheet(wb, createXlsxWorksheet(p, c1, c2), ));
    return wb;
}

function addCrosstabData(vm, def) {
    let crosstab = findCrosstab(vm, def.control1LevelId, def.control2LevelId);
    if (crosstab === null) {
        console.log(
            "Could not find crosstab for ",
            def.control1LevelId,
            def.control2LevelId
        );
        return;
    }
    def.controlLevels = crosstab.controlLevels;
    //def.models = crosstab.models;
    def.crosstab = crosstab;
    // def.noSourceRecords = crosstab.noSourceRecords;
    // def.isDataUnreliable = crosstab.isDataUnreliable;
    // def.totalSourceRecords = crosstab.totalSourceRecords;
    // def.tempInner = crosstab.$refs.crosstabTableCtl;

    //def.crosstabRows = crosstab.$refs.crosstabTableCtl.$refs.theRows;
    //def.crosstabRowTotal = crosstab.$refs.crosstabTableCtl.$refs.rowTotal;
}
function findCrosstab(vm, control1LevelId, control2LevelId) {
    if (control1LevelId === 0 && control2LevelId === 0)
        return vm.$refs.theCrosstab;

    let filtered = vm.$refs.theCrosstabs.filter((c) =>
        c.isControlLevel(control1LevelId, control2LevelId)
    );
    // console.log('def', def.control1LevelId, c.controlLevels.control1.id);
    // console.log('def2', def.control2LevelId, c.controlLevels.control2.id);

    return filtered.length > 0 ? filtered[0] : null;
}

function buildParameters(model, state) {
    var control1sFirstDataByControl2 = model.levelsGroupedByControl1[0].levelsGroupedByControl2;
    var p = {
        dataByControl1: model.levelsGroupedByControl1,
        control1sFirstDataByControl2: control1sFirstDataByControl2,
        control1MaxLength: current.selectionModel.v.control1.include ? Math.max.apply(null, model.levelsGroupedByControl1.map(c1 => c1.control1Level.title.length)) : 0,
        control2MaxLength: control1sFirstDataByControl2[0].control2Level ? Math.max.apply(null, control1sFirstDataByControl2.map(c2 => c2.control2Level.title.length)) : 0,
        statistics: model.usedStatistics,
        control1Levels: null,
        control2Levels: null,
        haveControl1: current.selectionModel.v.control1.include,
        haveControl2: current.selectionModel.v.control2.include,
        theReportModel: model,
        theState: state,
        theSelectionModel: current.selectionModel,

        //Supplied later

        theControl1: null,
        theControl2: null
    };
    if (p.haveControl1) {
        p.control1Levels = model.levelsGroupedByControl1.map(c => c.control1Level.title);
    }
    if (p.haveControl2) {
        p.control2Levels = control1sFirstDataByControl2.map(c => c.control2Level.title);
    }
    p.tabNames = p.dataByControl1[0].control1Level === null ? 'Crosstab' : getTabNames(p);
    return p;
}

function toLevelName(p, title, index, maxTitleWidth, limit) {
    if (maxTitleWidth <= limit)
        return title;
    else
        return index === 0 ? 'Total' : 'Level ' + index;
}
function formatTabName(p, control1Level, control1Index, control2Level, control2Index) {
    //console.log(control1Level, control2Level, stats)
    var limit = p.control2MaxLength === 0 ? 29 : 14;
    if (control1Index === 0 && (p.control2MaxLength === 0 || control2Index === 0))
        return 'Crosstab';
    if (p.control2MaxLength === 0) {
        return toLevelName(p, control1Level.title, control1Index, p.control1MaxLength, 29);
    }

    //return control1Level.title.substring(0, 29);
    if (p.control1MaxLength + p.control2MaxLength <= 29)
        return control1Level.title + ', ' + control2Level.title;
    else
        return toLevelName(p, control1Level.title, control1Index, p.control1MaxLength, 14) + ', ' +
            toLevelName(p, control2Level.title, control2Index, p.control2MaxLength, 14);
}
/*Call this before adding the row to get the correct row number*/





function writeChiSquare(p, sheet, chiSquare) {
    sheet.addRow([
        'Wald Chi-Square Value',
        chiSquare.valueIsNull ? '.' : common.getAsNumber(chiSquare.value.toFixed(2))
    ]);
    sheet.addRow([
        'Degrees of Freedom',
        chiSquare.valueIsNull ? '.' : common.getAsNumber(chiSquare.degreesOfFreedom)
    ]);
    sheet.addRow([
        'p-value',
        chiSquare.valueIsNull ? '.' : common.getAsNumber(chiSquare.displayPValue)
    ]);
}

function otherExcelExamples() {
    //var ext = typeof process !== 'undefined' && !!process.argv[2];

    //var cellMerges = [
    //  XLSX.utils.decode_range('A1:E2'),
    //  XLSX.utils.decode_range('A4:A5'),
    //  XLSX.utils.decode_range('C4:E4')];

    /* original rows */
    //var rows = [
    //  [heading],
    //  [],
    //  [],
    //  ['Falls: How many times have you fallen in the past 12 months, , adults 45 or more', '', 'Exercise: Exercised in past 30 days'],
    //  ['', 'Statistics', 'Yes', 'No', 'Row Total'],
    //  ['1 time', 'Sample Size', 133, 75, 208],
    //  []
    //  //[1, 2, 3],
    //  //[true, false, null, 'sheetjs'],
    //  //['foo    bar', 'baz', new Date('2014-02-19T14:30Z'), '0.3'],
    //  //['baz', null, '\u0BEE', 3.14159],
    //  //['hidden'],
    //  //['visible']
    //];

    //if (isNaN(rows[2][2].getYear()))
    //    rows[2][2] = new Date(Date.UTC(2014, 1, 19, 14, 30, 0));




    /* At 96 PPI, 1 pt = 1 px */
    //var wsrows = [
    //    { hpt: 12 }, // 'points'
    //    { hpx: 16 }, // 'pixels'
    //    ,
    //    { hpx: 24, level: 3 },
    //    { hidden: true }, // hide row
    //    { hidden: false }
    //];

    /* TEST: row props */
    //ws['!rows'] = wsrows;
    //ws['A1'] = {
    //    v: 'Abcd',
    //    s: {
    //        alignment: { textRotation: 90 },
    //        font: { sz: 14, bold: true }
    //        //font: { sz: 14, bold: true, color: '#FF00FF' }
    //    }
    //};
    //ws.A4 = {
    //    alignment: { wrapText: true }
    //}

    //cell.s = { alignment: { wrapText: true } }
}




function createIntroduction(p) {
    var introRows = introduction.slice();
    if (p.theSelectionModel.v.control1.include)
        addTabDescriptions(p, introRows);
    //tabNames.forEach(t1 =>
    //  t1.forEach(t2 => {

    //    console.log('tabs', newRow, sheet)
    //  }));
    introRows = introRows.concat(introductionDefinitions);
    var ws = XLSX.utils.aoa_to_sheet(introRows, { cellDates: true });
    return ws;
}

function getTabNames(p) {
    return p.dataByControl1.map((c1, i) => {
        return c1.levelsGroupedByControl2.map((c2, j) => {
            var name = formatTabName(p, c1.control1Level, i, c2.control2Level, j);
            return name;
        });
    });
}
function formatWorksheetName(p, i, j) {
    var workSheetName = 'Crosstab';
    if (p.haveControl1) {
        workSheetName = p.tabNames[i][j];
    }
    workSheetName = workSheetName.replace(/\//g, '-').substring(0, 30);
    return workSheetName;
}

function addTabDescriptions(p, introRows) {
    introRows.push([]);
    introRows.push(['Tabs in this Workbook:'])
    introRows.push(['', 'There is a different tab for each level of each control variable selected.  This tab will only include observations that are within that control variable level.']);
    var titleRow = ['', 'Tab Name', 'Control 1'];
    if (p.haveControl2)
        titleRow.push('Control 2');
    introRows.push(titleRow);
    p.dataByControl1.forEach((c1, i) => {
        c1.levelsGroupedByControl2.forEach((c2, j) => {
            var workSheetName = formatWorksheetName(p, i, j);
            var newRow = ['', workSheetName];
            if (i === 0 && j === 0) {
                newRow.push('This tab contains a Cross Tabulation which includes all relevent observations (including all levels of all control variables) in the crosstab output.')
            } else if (i === 0) {
                newRow.push('Not controlled by control 1')
                if (p.haveControl2)
                    newRow.push('Control 2 level of ' + p.control2Levels[j]);
            } else if (j === 0) {
                newRow.push('Control 1 level of ' + p.control1Levels[i]);
                if (p.haveControl2)
                    newRow.push('Not controlled by control 2');
            } else {
                newRow.push('Control 1 level of ' + p.control1Levels[i]);
                if (p.haveControl2)
                    newRow.push('Control 2 level of ' + p.control2Levels[j]);
            }
            introRows.push(newRow)
        });
    });
}

var introduction = [
    ['BRFSS Web Enabled Analysis Tool: Cross Tabulation'],
    [],
    ['Introduction:'],
    ['', 'Cross tabulations allow you to generate tables with frequencies across two or more categorical variables.']
];

var introductionDefinitions = [
    [],
    ['Definitions:'],
    ['', 'Cross-Tabulation:'],
    ['', 'Sample Size:'],
    ['', 'Row %:', 'Row percentage'],
    ['', 'C.I. for Row %:', '95% confidence interval for row percentage'],
    ['', 'S.E. of Row %:', 'standard error for row percentage'],
    ['', 'Column %:', 'column percentage'],
    ['', 'C.I. for Column %:', '95% confidence interval for column percentage'],
    ['', 'S.E. of Column %:', 'standard error for column percentage'],
    ['', 'Total % (Weighted):', 'total weighted percent'],
    ['', 'C.I. for Total % (Weighted):', 'confidence interval for total weighted percent'],
    ['', 'S.E. of Total % (Weighted):', 'standard error for total weighted percent'],
    ['', 'Weighted N:', 'weighted sample size'],
    ['', 'C.I. for Weighted N:', 'confidence interval for weighted sample size'],
    ['', 'S.E. of Weighted N:', 'standard error for weighted sample size'],
    ['', 'Wald Chi-Square Value:', 'statistic for wald chi-square test'],
    ['', 'Degrees of Freedom:', 'degrees of freedom for wald chi-square test'],
    ['', 'p-value:', 'p-value for wald chi-square test, usually if the p-value is less than or equal to 0.05 the test is considered statistically significant']];
